import { render, staticRenderFns } from "./CategoryFormDialog.vue?vue&type=template&id=68952612&scoped=true&"
import script from "./CategoryFormDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFormDialog.vue?vue&type=style&index=0&id=68952612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68952612",
  null
  
)

export default component.exports